import script from "./MaxioCompanySubscriptionPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxioCompanySubscriptionPlan.vue?vue&type=script&setup=true&lang=js"

import "./MaxioCompanySubscriptionPlan.vue?vue&type=style&index=0&id=5c992b5d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c992b5d"]])

export default __exports__